
    window.__hardReload = async function() {
      try {
        if ('serviceWorker' in navigator) {
          const regs = await navigator.serviceWorker.getRegistrations();
          await Promise.all(regs.map(r => r.unregister()));
        }
        if (window.caches && caches.keys) {
          const keys = await caches.keys();
          await Promise.all(keys.map(k => caches.delete(k)));
        }
        try { localStorage.clear(); } catch (_) {}
        try { sessionStorage.clear(); } catch (_) {}
        try {
          if (typeof indexedDB !== 'undefined' && indexedDB.databases) {
            const dbs = await indexedDB.databases();
            await Promise.all((dbs || []).map(db => new Promise(resolve => {
              const req = indexedDB.deleteDatabase(db.name);
              req.onsuccess = req.onerror = req.onblocked = () => resolve();
            })));
          }
        } catch (_) {}
        try {
          document.cookie.split(';').forEach(c => {
            const i = c.indexOf('=');
            const name = (i > -1 ? c.substr(0, i) : c).trim();
            if (name) {
              document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
            }
          });
        } catch (_) {}
      } catch (e) {
      } finally {
        location.reload();
      }
    };

    (function(){
      const originalError = console.error;
      console.error = function() {
        try {
          const args = Array.from(arguments);
          if (args.some(a => typeof a === 'string' && a.toLowerCase().includes('failed to connect to websocket'))) {
            const fb = document.getElementById('blank-fallback');
            if (fb) fb.style.display = 'flex';
            const hard = document.getElementById('hard-reload');
            if (hard) hard.style.display = 'inline-block';
          }
        } catch(_){}
        return originalError.apply(console, arguments);
      }
    })();

    const isProdd = typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.PROD;
    if (isProdd && 'serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/firebase-messaging-sw.js')
          .then((registration) => {
            console.log('✅ Service Worker Unificado registrado exitosamente:', registration.scope);
            registration.addEventListener('updatefound', () => {
              const newWorker = registration.installing;
              newWorker && newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  console.log('🔄 Nueva versión del Service Worker disponible');
                }
              });
            });
          })
          .catch((error) => {
            console.log('❌ Error registrando Service Worker:', error);
          });
      });
    } else {
      console.log('ℹ️ SW deshabilitado en desarrollo para evitar conflictos con HMR');
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister()));
      }
    }
  